import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoVentas from "../ventas/InfoVentas";
const Footer = lazy(() => import('../footer/Footer'));
function Ventas() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai cuenta con agencias a nivel nacional. Revisa la ubicación e información relevante de todos nuestros puntos de venta"
        />
        <meta
          name="keywords"
          content="Agencias Hyundai, Ventas, red de concesionarios, concesionario hyundai"
        />
        <title>Concesionarios Hyundai</title>
      </Helmet>
      <Menu />
      <InfoVentas />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Ventas;